import React from "react"

export default function ButtonCollapse() {
  return (
    <button type="button" className="btn btn-tool" data-card-widget="collapse" title="Réduire">
      <i className="fas fa-minus" />
    </button>
  )
}
